
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (value: string) => {
    console.log('Changing language to:', value);
    i18n.changeLanguage(value);
  };

  return (
    <Select 
      value={i18n.language} 
      onValueChange={handleLanguageChange}
    >
      <SelectTrigger className="w-[80px] bg-background">
        <SelectValue>
          <span className="text-lg">
            {i18n.language === 'fr' ? '🇫🇷' : '🇬🇧'}
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="fr">
          <span className="text-lg">🇫🇷</span>
        </SelectItem>
        <SelectItem value="en">
          <span className="text-lg">🇬🇧</span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};

export default LanguageSelector;
